import { atom } from "jotai";

interface Teams {
    groupID: string;
    name: string;
    created: string;
    modified: string | null;
    groupType: string;
    startDate: string | null;
    endDate: string | null;
    weekEndDay: string | null;
    visibility: string;
    presentationEnabled: number;
    ratings: string;
    orgID: string;
    canMembersViewPresentations: number;
    isInstructorGeneralVisible: number;
    isGeneralVisible: number;
    isInstructorEngagementsVisible: number;
    periodLabel: string;
    alternativeCanvasType: string;
    isInstructorChatVisible: number;
    isInstructorFeedbackVisible: number;
    isPresentationLinksVisible: number;
    defaultCanvasView: string;
    isInterviewVisibleInStatsBeforeStartDate: number;
    canMembersViewPresentationFeedback: number;
    isLeanCanvasFull: number;
    isPrivatePresentationChatVisible: number;
    createdF: string;
    modifiedF: string | null;
    canvasLayoutID: string;
    defaultCanvasLayoutID: string | null;
    canvasLayoutIDLocked: number;
    isAiInsightGenerationEnabled: number;
    id: string;
    type: string;
}

export interface TeamCollections {
    [groupID: string]: Teams;
}


const INITIAL_TEAMS_IN_ATOM_VALUE: TeamCollections = {};


export const teamsAtom = atom<TeamCollections>(INITIAL_TEAMS_IN_ATOM_VALUE);


export const setTeamsAtom = (set: Function, value: TeamCollections) => {
    set(teamsAtom, value);
};
